import React, { Component, useState } from 'react';
import { getColumns, resolveLocalFiltersConfiguration, requiredFields, TYPE } from 'Views/incidents';
import Theme from '@uilib/business-components/_utils/theme';
import Button from 'uilib-wrappers/button';
import Modal from 'uilib-wrappers/modal';
import Tooltip from 'uilib-wrappers/tooltip';

import { Navigator } from 'Services';
import { withBackend } from 'Services/backend';
import { AppContext } from 'Services/AppContext';
import Grid from 'Bricks/Grid/Grid';
import { isIncidentClosed } from 'Bricks/Helpers';

const DB_TYPE = window.serverInfo.constants.dbObject;

const INCIDENT_SELECTION_MODAL_THEME = {
    Modal: {
        maxWidth: '80%',
        maxHeight: '90%',
        width: '80%',
        height: '90%',
        innerPadding: '0px',
    },
};

class IncidentsGrid extends Component {
    static contextType = AppContext;
    constructor(props) {
        super(props);

        this.state = {
            menuPortalTarget: null,
        };

        this.gridApi = null;

        this.gridOptions = {
            resetLocalFilters: false,
            requiredFields,
            columns: getColumns(TYPE.ADD_TO),

            isRowStatusInfo: (entity) => {
                return entity.current;
            },
            onRowClicked: this.props.onRowClicked,
            onRowSelectionChanged: this.onRowSelectionChanged,
            preselectedItems: this.getPreselectedItems,
            onRegisterApi: (gridApi) => {
                this.gridApi = gridApi;
            },
            onReload: this.onReload,
            url: 'incidents',
            disableFooter: true,
            disableSelection: false,
            disableSelectAll: true,
        };
    }

    reload = () => {
        this.gridApi.reloadData();
        this.props.setSelectedIncident(null);
    };

    onReload = () => {
        this.props.setSelectedIncident([]);
    };

    onRowSelectionChanged = (entities) => {
        this.props.setSelectedIncident(entities);
    };

    componentDidMount() {
        this.setState({ menuPortalTarget: document.getElementById(this.props.id) });
    }

    render() {
        return (
            <Grid
                id={this.props.id}
                menuPortalTarget={this.state.menuPortalTarget}
                title="INCIDENTS"
                storage={this.props.storage}
                options={this.gridOptions}
                localFiltersOptions={resolveLocalFiltersConfiguration.call(this, TYPE.ADD_TO)}
                singleSelectionMode={true}
                disableGroupChangeSubscribe={true}
            />
        );
    }
}

function IncidentSelectionModal(props) {
    const [selectedIncidents, setSelectedIncidents] = useState([]);

    function onAddToIncident() {
        selectedIncidents[0] && props.onAddToIncident(selectedIncidents[0]);
    }

    function handleRowClicked(event, entity) {
        Navigator.go(event, 'console.incident.graph', {
            incidentId: entity.id,
            incidentVersion: entity.objectsVersion,
        });
    }

    return (
        <Theme.Provider theme={INCIDENT_SELECTION_MODAL_THEME}>
            <Modal
                id={props.id}
                show={props.showIncidentSelectionModal}
                title="SELECT_INCIDENT"
                onDispose={props.closeIncidentSelectionModal}
                buttons={[
                    <Tooltip
                        tooltipContent="OPERATION_ON_CLOSED_INCIDENT_DESCRIPTION"
                        disabled={
                            !selectedIncidents?.length ||
                            selectedIncidents?.length > 1 ||
                            !isIncidentClosed(selectedIncidents[0]?.status)
                        }
                        id="eid-add-to-selected-incident-tooltip"
                    >
                        <div>
                            <Button
                                id="eid-add-to-selected-incident"
                                onClick={onAddToIncident}
                                disabled={
                                    !selectedIncidents?.length ||
                                    selectedIncidents?.length > 1 ||
                                    isIncidentClosed(selectedIncidents[0]?.status)
                                }
                                text="ADD_TO_SELECTED_INCIDENT"
                            />
                        </div>
                    </Tooltip>,
                    <Button
                        id="eid-cancel-incident-selection"
                        type="secondary"
                        onClick={props.closeIncidentSelectionModal}
                        text="CANCEL"
                    />,
                ]}
            >
                <IncidentsGrid
                    id={props.id}
                    menuPortalTargetId={props.id}
                    setSelectedIncident={setSelectedIncidents}
                    storage="addToIncidentModal"
                    onRowClicked={handleRowClicked}
                />
            </Modal>
        </Theme.Provider>
    );
}

export default withBackend(IncidentSelectionModal);
